var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classObject,style:([_vm.defaultCssVariables, _vm.cssVariables])},[_c('div',{staticClass:"fixed",class:_vm.inputSizeClass},[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","id":_vm.id,"name":_vm.name},domProps:{"value":_vm.value},on:{"input":_vm.updateValue}})])
}
var staticRenderFns = []

export { render, staticRenderFns }